import './Button.scss';
import React from 'react';

function Button({ children, label, active, onClick, className }) {

  return (
    <button type="button" onClick={e => onClick(e)} className={'button' + (active ? ' active' : '') + (className ? ` ${className}` : '') }>
      { label || children }
    </button>
  );
}

export default Button;
